module.exports = __webpack_public_path__ + "static/img/guide-05.9072d139.png";